module.exports = __webpack_public_path__ + "static/media/bars-drop-icon.a18fe7bf.svg";